import { intelClient } from 'src/api/config';

function fetchUserInfo() {
  return intelClient.get('/api/insights/user');
}

export default fetchUserInfo;
